<template>
  <div class="guide-container" @click.stop="$emit('close')">
    <img class="img-1" :src="require('@/assets/share/share_poster_1.svg')">
    <img class="img-2" :src="require('@/assets/share/share_poster_2.svg')">
    <img class="img-3" :src="require('@/assets/share/share_poster_3.svg')">
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.guide-container {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 1100;
  background-color: rgba(0,0,0,0.6);
  .img-1 {
    position: absolute;
    right: 40px;
    top: 0;
    width: 260px;
  }
  .img-2 {
    position: absolute;
    right: 298px;
    top: 228px;
    width: 288px;
  }
  .img-3 {
    position: absolute;
    bottom: 120px;
    left: 50%;
    width: 300px;
    margin-left: -150px;
  }
}
</style>